import { apiToken, isVerifiedURL, sendOTPURL, verifyOTPURL } from "../config";
// send otp start
export const sendOTP = async (phoneNumber) => {
    try {
        const response = await fetch(sendOTPURL, {
            method: 'POST',
            headers: {
                'COntent-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
            body: JSON.stringify({ phone: phoneNumber })
        });

        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Network response was not ok");
        }
        return res;

    } catch(e) {
        console.error(e.message || "Failed to send OTP");
        throw new Error(e.message || "Failed to send OTP");
    }
}

// send otp end

// verify otp start
export const verifyOTP = async ( phoneNumber, otp ) => {
    try {
        const response = await fetch(verifyOTPURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
            body: JSON.stringify({ phone: phoneNumber, otp })
            
        });
        const res = await response.json();

        if (!response.ok) {
            throw new Error(res.message || "Network response was not ok");  
        }

        return res;
    } catch(e) {
        console.error(e.message || "Failed to verify OTP");
    }
}

// verify otp end

// is verifeed start

export const isVerifiedPhoneNumber = async (phoneNumber) => {
    try {
        const response = await fetch(`${isVerifiedURL}?phone=91${phoneNumber}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        })
        const res = await response.json();
        console.log(res, 'response from isVerifiedPhoneNumber');
        // if (!response.ok) {
        //     throw new Error(res.message || "Network response was not ok");
        // }
        return res;

    } catch(e) {
        throw new Error(e.message || "Failed to check verification status");
    }
}

// is verified end